import { Block, Navbar, Page } from "framework7-react";

import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

const NotFoundPage = createPage("NotFoundPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar
        backLink="Back"
        title="Not found"
      />
      <Block
        inset
        strong
      >
        <p>Sorry</p>
        <p>Requested content not found.</p>
      </Block>
    </Page>
  );
}

export default NotFoundPage;
